import React from 'react';

export interface ProductRatingProps {
    rating?: number;
}

const maxRating = 10;

export const ProductRating = ({ rating }: ProductRatingProps) => {
    const stars = [];
    if (rating) {
        const fullStars = Math.floor(rating / 2);
        const showHalfStar = rating % 2 === 1;
        const emptyStars = Math.floor((maxRating - rating) / 2);
        let key = 0;

        stars.push(
            [...Array(fullStars)].map(() => (
                <img key={key++} src="/dist/assets/images/star-100.png" className="ProductRating__Star-Icon" alt={'Rating start - Full'} />
            ))
        );

        if (showHalfStar)
            stars.push(<img key={key++} src="/dist/assets/images/star-50.png" className="ProductRating__Star-Icon" alt={'Rating start - Half'} />);

        stars.push(
            [...Array(emptyStars)].map(() => (
                <img key={key++} src="/dist/assets/images/star-0.png" className="ProductRating__Star-Icon" alt={'Rating start - Empty'} />
            ))
        );
    }

    return <div className="ProductRating__Wrapper">{stars}</div>;
};
